import styled, { css } from 'styled-components';
import { Border, InnerContainer, itemColorStates } from './ItemContainer';

export type DndVariant = 'over' | 'dragging';

type DraggableContainerProps = {
  $dndVariant?: DndVariant;
};

export const DraggableContainer = styled.div<DraggableContainerProps>`
  ${(p) =>
    p.$dndVariant === `over` &&
    css`
      ${InnerContainer} {
        background: ${itemColorStates.over};
      }
      ${Border} {
        border: solid 1px ${itemColorStates.overBorder};
      }
    `}
`;
